module.exports = __webpack_public_path__ + "static/img/beacon_256.effac29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/beacon_256.png
// module id = 3n94
// module chunks = 0